import React from 'react';
import PropTypes from 'prop-types';
import root from 'window-or-global';
import Swiper from 'swiper';
import classNames from 'classnames';
import WheelIndicator from 'wheel-indicator';

export default class SectionSwiper extends React.Component {
    static propTypes = {
        sections: PropTypes.array,
        setIsFinal: PropTypes.func
    };

    static defaultProps = {
        sections: [],
        setIsFinal: fn => fn
    }

    state = {
        activeIndex: 0,
        animating: this.swiper && this.swiper.animating
    }

    componentDidMount = () => {
        this.swiper = new Swiper(this.swiperContainer, {
            autoHeight: true,
            direction: 'vertical',
            mousewheel: false,
            on: {
                slideChange: () => {
                    this.setState({activeIndex: this.swiper.activeIndex});
                },
                transitionEnd: () => {
                    const { anchor } = this.props.sections[this.swiper.activeIndex].props.block;
                    root.location.hash = anchor ? `#${anchor}` : '';
                },
                progress: () => {
                    if (!this.swiper) return;
                    this.props.setIsFinal(this.swiper.progress === 1 ? true : false);
                }
            },
            pagination: {
                el: this.pagination,
                clickable: true
            },
            resistanceRatio : 0,
            slidesPerView: 'auto',
            speed: 800
        });

        this.matchHash();

        new WheelIndicator({
            elem: this.swiperContainer,
            callback: e => {
                if (this.swiper.animating) return;
                if (e.direction === 'up') this.swiper.slidePrev();
                else this.swiper.slideNext();
            }
        });
    }

    matchHash = () => {
        const hash = root.location.hash;
        if (!hash) return;
        this.props.sections.forEach((section, index) => {
            const { block } = section.props;
            if (!block || !block.anchor) return;
            if (hash === `#${block.anchor}`) this.swiper.slideTo(index);
        })
    }

    scrollToTop = () => this.swiper.slideTo(0)
    handlePrev = () =>  this.swiper.slidePrev();
    handleNext = () => this.swiper.slideNext();

    render() {
        const { sections } = this.props;
        const { activeIndex, animating } = this.state;

        return (
            <div className="section-swiper swiper-container" ref={el => this.swiperContainer = el}>
                <div className="swiper-wrapper">
                    {
                        sections.map((section, index) => (
                            <section
                                className={classNames('swiper-slide', section.adpativeHeight ? '' : 'full-height')}
                                key={index}>
                                <section.component
                                    handlePrev={this.handlePrev}
                                    handleNext={this.handleNext}
                                    active={activeIndex === index && !animating}
                                    upOnClick={section.hasUpOnClickProp && this.scrollToTop}
                                    {...section.props} />
                            </section>
                        ))
                    }
                </div>
                <div className="swiper-pagination" ref={el => this.pagination = el} />
            </div>
        );
    }
}
